module.exports = __webpack_public_path__ + "media/images/niq-add-new-c47e03d99cfeb2b07eecd169e33cd61d.svg";